/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Store } from "redux";

import { setOnline, setToken } from "../store/actions";
import { RootState } from "../types/RootState";
import { ApiService } from "./Api.service";
import { AuthService } from "./Auth.service";

export class Services {
    public api: ApiService;
    public auth: AuthService;

    private store: Store<RootState>;

    constructor() {
        this.api = this._buildApi();
        this.auth = this._buildAuth();
    }

    public async init(store: Store<RootState>) {
        this.initStore(store);
    }

    public initStore(store: Store<RootState>) {
        this.store = store;
        this._observeStore(
            (state: RootState) => state.env,
            (env: { [key: string]: string }) => {
                this.api.setBaseUrl(env.APP_API_URL);
                this.auth.init(env);
            }
        );
        this._observeStore(
            (state: RootState) => state.auth.token,
            (token: string) => {
                this.api.setAuthToken(token);
            }
        );
        this.auth.onRefreshToken((newToken: string) => {
            this.store.dispatch(setToken(newToken));
        });
        // Handle Online/Offline in store
        window.addEventListener("offline", (e) => {
            this.store.dispatch(setOnline(false));
        });
        window.addEventListener("online", (e) => {
            this.store.dispatch(setOnline(true));
        });
    }

    /* Immplementation. */

    private _buildApi(): ApiService {
        return new ApiService();
    }

    private _buildAuth(): AuthService {
        return new AuthService();
    }

    private _observeStore<T>(select: (state: RootState) => T, onChange: (state: T) => void) {
        let currentState: T = null;

        const handleChange = () => {
            const nextState: T = select(this.store.getState());
            if (nextState !== currentState) {
                currentState = nextState;
                onChange(currentState);
            }
        };

        const unsubscribe = this.store.subscribe(handleChange);
        handleChange();
        return unsubscribe;
    }
}



// WEBPACK FOOTER //
// ./src/services/Services.ts